<template>

  <v-card
    color="light-blue darken-4 white--text" class="d-flex flex-column pl-10"
  >
      
        <div class="d-flex justify-end">
          <v-col class="py-0 px-0" cols="12" sm="12" md="11" lg="11" xl="11" v-show="isAuthenticated && !this.isTrueValue(delegatedUser)" align="center" justify="center">
            <v-select
                dense
                :items="getAssociatedAgencies"
                :label="labelOrgão"
                v-model="sourceSelected"
                class="text-caption active && mb-4"
                background-color="ligthblue"
                solo
                style="height:20px"
                id="cboOrgaosPermitidos"
                v-if="showDDLAgency"
            >
              <template #selection="{ item }">
                <label color="white">{{ (item) ? item.text : ''}}</label>
              </template>          
            </v-select>
            
          </v-col>
        </div>
        <div class="d-flex justify-start align-center">
          <div class="d-flex flex-column justify-start">
            <div v-if="isAuthenticated && (this.sourceSelected && this.sourceSelected.text)"  align="rigth" justify="rigth">
                <v-tooltip top v-if="isButtonChangeSearchVisible && !isOnlyAgencyUser && !isLoginPage">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon 
                      v-bind="attrs"
                      v-on="on"
                      color="white"
                      right
                      elevation="0"
                      @click="showButtonChangeSearch(false)"
                    >
                      <v-icon>mdi-swap-vertical-circle-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Alterar o órgão solicitante</span>
                </v-tooltip>           
                <span class="text-caption active && mb-4">{{ (this.sourceSelected && this.sourceSelected.text)? this.sourceSelected.text : '' }}</span>
            </div>
            <div v-if="isAuthenticated" class="pl-2">           
                <span class="text-caption active && mb-4">{{ userLogin }} | {{ userName }}</span>
            </div>
          </div>
        </div>
        <!-- <v-col  cols="12" sm="12" md="12" v-if="isAuthenticated">
            Tempo de expiração: {{ timeToExpiresSession }}
        </v-col> -->
        <div class="d-flex justify-end">
          <v-col cols="12" sm="12" md="11" lg="11" xl="11" class="py-1 px-1">
            <v-btn icon v-if="isAuthenticated"
              color="white" 
              tooltip="Sair"
              right 
              elevation="0"
              @click="logout()">
              <v-icon>mdi-logout</v-icon>SAIR
            </v-btn>
          </v-col>
        </div>
        <v-dialog
            v-model="dialogSessionExpires"
            width="500"
        >
            <v-card>
                <v-card-title class="light-blue darken-4 white--text">
                Tempo de sessão expirando
                </v-card-title>

                <v-card-text>
                <br/>
                  <p>Sua sessão irá expirar em : <span class="font-weight-bold">{{ timeAlertExpirationShow }} minutos.</span></p>
                  <p>Hora de exibição do alerta: {{ timeToShowAlert }}</p>

                </v-card-text>

                

                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                    color="primary"
                    elevation="0"
                    large
                    rounded
                    @click="dialogSessionExpires = false"
                >
                    CONFIRMAR
                </v-btn>
                </v-card-actions>
            </v-card>    
        </v-dialog>

  </v-card>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex';
import moment from 'moment';

export default {
  data() {
    return {
      environment: process.env.NODE_ENV,
      timeToExpiresSession: null,
      timeAlertExpirationShow: 0,
      timeToShowAlert: '',
      dialogSessionExpires: false,
      labelOrgão: 'Órgão Solicitante',
      sourceSelected: '',
      isButtonChangeSearchVisible: false,
      hasButtonChangeSearchClicked: false,
      showDDLAgency: true,
      isOnlyAgencyUser: false,
    };
  },
  computed: {
    ...mapGetters('login', ['userLogin','userName','isAuthenticated','getAssociatedAgencies','delegatedUser','isLoginPage']),
    ...mapGetters('common', [ 'getSourceSearchSelected','getPreviousPage' ]),
  },
  mounted(){
    this.getTimeToExpiresSession();
    window.setInterval(() => {
      this.getTimeToExpiresSession()
    }, 120000);
    this.setSourceSearch();
    this.$root.$on('header_setSourceSearch', () => {
        this.setSourceSearch();
    });
  },
  methods: {
        ...mapMutations('common', ['updateSourceSearch','updateRequestingAgency','updateEnabledReordering','updateSourceSearchSelected', 'updateEnabledConvalescence', 'updateEnabledOnlyReordering']),    
        ...mapMutations('request', ['listRequest']),
        logout() {
            this.$store
            .dispatch('login/logout')
            .then(() => this.$router.push('/', () => {}, () => {}));
        },
        getTimeToExpiresSession(){
            let tkEpx = (this.$store.state.login.tokenExpiration != null)? moment(this.$store.state.login.tokenExpiration) : null;
            let tokenValid = (tkEpx != null && tkEpx._isValid);
            if(tokenValid){
              let agora = moment().local();
              let tempo = moment.duration(tkEpx.diff(agora));
              //return tkEpx.format('HH:mm:ss');
              if(!isNaN(tempo.minutes()))
                this.timeToExpiresSession = tempo.hours().toString().padStart(2,"0") + ":" + tempo.minutes().toString().padStart(2,"0") + "h";

              let minutesToExpires = tempo.minutes();
              let hoursToExpires = tempo.hours();

              if (hoursToExpires == 0 && minutesToExpires < 1){
                  this.timeAlertExpirationShow = 0;
                  this.timeToExpiresSession = '';
                  this.logout();
                  return true;
              }


              if(hoursToExpires == 0 && (minutesToExpires < 3 && this.timeAlertExpirationShow != 2))
              {
                //alert('Sua sessão irá expirar em menos de 2 minutos. Assim que puder faça o login novamente.');
                this.timeAlertExpirationShow = 2;
                this.timeToShowAlert = agora.hours().toString().padStart(2,"0") + ":" + agora.minutes().toString().padStart(2,"0") + "h";
                this.dialogSessionExpires = true;
                return true;
              }
              
              if(hoursToExpires == 0 && (minutesToExpires < 6  && this.timeAlertExpirationShow != 5))
              {
                //alert('Sua sessão irá expirar em menos de 5 minutos. Assim que puder faça o login novamente.');
                this.timeAlertExpirationShow = 5;
                this.timeToShowAlert = agora.hours().toString().padStart(2,"0") + ":" + agora.minutes().toString().padStart(2,"0") + "h";
                this.dialogSessionExpires = true;
                return true;
              }
              
              if(hoursToExpires == 0 && (minutesToExpires < 11  && this.timeAlertExpirationShow != 10)){
                //alert('Sua sessão irá expirar em menos de 10 minutos. Assim que puder faça o login novamente.');
                this.timeToShowAlert = agora.hours().toString().padStart(2,"0") + ":" + agora.minutes().toString().padStart(2,"0") + "h";
                this.timeAlertExpirationShow = 10;
                this.dialogSessionExpires = true;
                return true;
              }
            }
        },
        changeSourceSearch(item){
          if(item == null || item == undefined || item.length == 0){
            this.labelOrgão = "Órgão Solicitante";
            this.sourceSelected = '';
            this.isButtonChangeSearchVisible = false;
            this.showDDLAgency = !this.isButtonChangeSearchVisible && !this.isOnlyAgencyUser;
            if(!this.hasButtonChangeSearchClicked && !this.isTrueValue(this.delegatedUser))
              alert('Deve ser selecionado um órgão');
            return false;
          }

          console.log('xx-2', item);
       
          console.log('this.getAssociatedAgencies', this.getAssociatedAgencies);

          if(this.getAssociatedAgencies != null && this.getAssociatedAgencies != undefined){
            if(this.getAssociatedAgencies.length > 1){
              let arrValue = item.split('|');
              
              console.log('x1', arrValue);
              
              this.updateSourceSearch(arrValue[0]);
              this.updateRequestingAgency((arrValue[1] == "-1" || arrValue[1] === "-1") ? null : arrValue[1]);
              this.updateEnabledReordering(this.isTrueValue(arrValue[2]));
              this.updateEnabledOnlyReordering(this.isTrueValue(arrValue[4]));
              this.updateSourceSearchSelected(item);
              this.updateEnabledConvalescence(arrValue[3])
              this.sourceSelected = this.getAssociatedAgencies.find(e => e.value == item);
              this.isButtonChangeSearchVisible = true;
            } else if(this.getAssociatedAgencies.length == 1){
                let lstAgencies = this.getAssociatedAgencies;
                let arrValue = lstAgencies[0].value.split('|');

                console.log('x2', arrValue);

                this.updateSourceSearch(arrValue[0]);
                this.updateRequestingAgency((arrValue[1] == "-1" || arrValue[1] === "-1") ? null : arrValue[1]);
                this.updateEnabledReordering(this.isTrueValue(arrValue[2]));
                this.updateEnabledOnlyReordering(this.isTrueValue(arrValue[4]));
                this.updateSourceSearchSelected(lstAgencies[0].value);
                this.updateEnabledConvalescence(arrValue[3])
                this.sourceSelected = lstAgencies[0];
                this.isButtonChangeSearchVisible = false;
            }
            this.showDDLAgency = !this.isButtonChangeSearchVisible && !this.isOnlyAgencyUser;
            let valueListRequestCleared = [];
            this.listRequest(valueListRequestCleared);

          } 
        },
        isTrueValue(value){
            let isTrue = ((value != null) && (value != undefined) && (value.toString().toLowerCase() == "true" || value == "1" || value == true || value === 1));
            return isTrue;
        },
        setSourceSearch(){

            console.log("Órgão Solicitante 02");

            if(this.getPreviousPage != 'login')
              return true;
              
            let lstAgencies = this.$store.state.login.associatedAgencies;
            this.sourceSelected = '';
            this.isButtonChangeSearchVisible = false;
            if(lstAgencies != null && lstAgencies != undefined && lstAgencies.length == 1)
            {
                let arrValue = lstAgencies[0].value.split('|');

                this.updateSourceSearch(arrValue[0]);
                this.updateRequestingAgency((arrValue[1] == "-1" || arrValue[1] === "-1") ? null : arrValue[1]);
                this.updateEnabledReordering(this.isTrueValue(arrValue[2]));
                this.updateEnabledOnlyReordering(this.isTrueValue(arrValue[4]));
                this.updateSourceSearchSelected(lstAgencies[0].value);
                this.updateEnabledConvalescence(arrValue[3]);
                this.sourceSelected = lstAgencies[0];
                this.isOnlyAgencyUser = true;
            } else if(lstAgencies != null && lstAgencies != undefined && lstAgencies.length > 1){
              this.isOnlyAgencyUser = false;
            }
            let valueListRequestCleared = [];
            this.listRequest(valueListRequestCleared);
            this.showDDLAgency = !this.isButtonChangeSearchVisible && !this.isOnlyAgencyUser;
        },
        showButtonChangeSearch(value){
          console.log("Órgão Solicitante 03");
          if(value == false){
            this.updateSourceSearch('');
            this.updateRequestingAgency('');
            this.updateEnabledReordering(false);
            this.updateEnabledOnlyReordering(false);
            this.updateSourceSearchSelected('');
            console.log("ListRequest 04");
            this.$router.push('ListRequest').catch(err => {
                            // Ignore the vuex err regarding  navigating to the page they are already on.
                            if (
                              err.name !== 'NavigationDuplicated' &&
                              !err.message.includes('Avoided redundant navigation to current location')
                            ) 
                            {
                              console.log('err ao mudar tipo Orgão Solicitante: ', err);
                            }
                          });        
          }
          this.isButtonChangeSearchVisible = value;
          this.showDDLAgency = !this.isButtonChangeSearchVisible && !this.isOnlyAgencyUser;
          this.sourceSelected = '';
          this.hasButtonChangeSearchClicked = true;
          let valueListRequestCleared = [];
          this.listRequest(valueListRequestCleared);
        }
  },
  watch: {
    sourceSelected(newValue){
      if(newValue.value)
        this.changeSourceSearch(newValue.value);
      else
        this.changeSourceSearch(newValue);
      console.log('Valor vuex: ', this.getSourceSearchSelected);
      console.log('newValue.value: ', newValue.value);
      console.log('newValue: ', newValue);
      //console.log('Valor antigo: ' , ((oldValue)?oldValue.value: 'ni') , ' - Nome: ' , ((oldValue)?oldValue.text:'ni'));
     // console.log('Valor novo: ' , newValue.value , ' - Nome: ' , newValue.text);
    },
  }
}
</script>

<style scoped>
.title,
.subtitle {
  /*color: #fff;*/
}

.project {
  display: inline-block;
  position: absolute;
  right: 0;
  top: 0;
  width: 150px;
  height: 150px;
}

</style>